module.exports = __webpack_public_path__ + "img/creamy-desktop.33ff37d5.jpg";